import {
  Box,
  Button,
  Container,
  Heading,
  Input,
  Text,
  VStack
} from "@chakra-ui/react";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { mockApi, type LoginData } from "../api/mockApi";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const loginMutation = useMutation({
    mutationFn: (data: LoginData) => mockApi.login(data),
    onSuccess: (user) => {
      console.log("Login successful:", user);
      // In a real app, you'd store the token in localStorage or a auth context
      localStorage.setItem("authToken", user.token);
      localStorage.setItem("user", JSON.stringify(user));
      navigate("/links");
    },
    onError: (error) => {
      console.error("Login failed:", error);
    }
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    loginMutation.mutate({ email, password });
  };

  return (
    <Container
      maxW="md"
      h="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box w="full" maxW="400px" bg="white" shadow="xl" rounded="lg" p={8}>
        <VStack gap={6}>
          <Heading size="lg" textAlign="center" color="blue.600">
            Welcome Back
          </Heading>
          <Text textAlign="center" color="gray.600">
            Sign in to your account
          </Text>

          <Box as="form" w="full" onSubmit={handleSubmit}>
            <VStack gap={4}>
              <Box w="full">
                <Text mb={2} fontWeight="medium">
                  Email
                </Text>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  disabled={loginMutation.isPending}
                  required
                />
              </Box>

              <Box w="full">
                <Text mb={2} fontWeight="medium">
                  Password
                </Text>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  disabled={loginMutation.isPending}
                  required
                />
              </Box>

              {loginMutation.error && (
                <Box p={3} bg="red.50" color="red.600" rounded="md" w="full">
                  {loginMutation.error.message}
                </Box>
              )}

              <Button
                type="submit"
                colorPalette="blue"
                w="full"
                size="lg"
                loading={loginMutation.isPending}
              >
                Sign In
              </Button>
            </VStack>
          </Box>
        </VStack>
      </Box>
    </Container>
  );
}

export default Login;
